"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomeErrorConverter_1 = __importDefault(require("./util/CustomeErrorConverter"));
/**
 * Fires on grammar errors.
 */
class CustomErrorListener {
    constructor(cqlResult) {
        this.cqlResult = cqlResult;
    }
    syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg) {
        if (offendingSymbol) {
            this.cqlResult.errors.push({
                text: offendingSymbol.text,
                start: {
                    line,
                    position: offendingSymbol.charPositionInLine,
                },
                stop: {
                    line,
                    position: offendingSymbol.charPositionInLine +
                        (offendingSymbol.stopIndex - offendingSymbol.startIndex) +
                        1, // plus 1 to ensure full text is included in Ace Editor highlight
                },
                name: offendingSymbol.text,
                message: (0, CustomeErrorConverter_1.default)(msg),
            });
        }
    }
}
exports.default = CustomErrorListener;
//# sourceMappingURL=CustomErrorListener.js.map